import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'cifempresa', namespaced: true })

export default mystore
